module.exports = __webpack_public_path__ + "img/emoji_13.9a1c22ad.png";